import { Component } from 'react'

import Input from './Input'

export default class InputNumber extends Component {
  static displayName = 'InputNumber'

  validate(value: any, element: any) {
    const isValid = element && !element.validity.badInput
    if (!isValid) {
      return 'Must be a Number'
    }
  }

  render() {
    return <Input {...this.props} type="number" validateOverride={this.validate} />
  }
}
